module.exports = __webpack_public_path__ + "static/media/share.0584f211.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/share.svg
// module id = 470
// module chunks = 0